import {useEffect} from "react";
import {ThinCloseIcon, ThinWarningIcon} from "../../components/icons/material-icons";

export const SignupTempDisableModal = (props: { active: boolean, closeHandler: any }) => {
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div><b>تکمیل ظرفیت</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <div className="signup-disable-modal">
                            <i>
                                <ThinWarningIcon/>
                            </i>
                            <b>ظرفیت ثبت‌نام تکمیل شد</b>
                            <p>
                                اولیای محترم،
                                <br/>
                                ضمن قدردانی از همراهی گرم شما، به اطلاع می‌رسانیم که ظرفیت ثبت‌نام در این مرحله به‌طور کامل تکمیل شده است.
                                <br/>
                                در صورت ایجاد ظرفیت‌های جدید، مراتب از طریق سامانه یا کانال‌های اطلاع‌رسانی رسمی به آگاهی خواهد رسید.
                                <br/>
                                با سپاس از اعتماد شما و آرزوی توفیق برای فرزندان عزیزتان
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};